export const dateRangePresets = {
  past24Hours: 1,
  past48Hours: 2,
  past72Hours: 3,
  pastTwoWeeks: 14,
  pastMonth: 30,
  pastThreeMonths: 90,
}

export const dateRangeShortcuts = [
  { label: 'Past 24 hours', shortLabel: '24H', value: 'past24Hours' },
  { label: 'Past 48 hours', shortLabel: '48H', value: 'past48Hours' },
  { label: 'Past 72 hours', shortLabel: '72H', value: 'past72Hours' },
  { label: 'Past two weeks', shortLabel: '2W', value: 'pastTwoWeeks' },
  { label: 'Past month', shortLabel: '1M', value: 'pastMonth' },
  { label: 'Past three months', shortLabel: '3M', value: 'pastThreeMonths' },
]
